// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"8bb43be0","666":"ca18b6a1"}[chunkId] + ".chunk.css";
};